var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_314_1572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 11.3333V10.6667H8.66667V8.66667H10.6667V10H12V11.3333H11.3333V12.6667H10V14H8.66667V12H10V11.3333H10.6667ZM14 14H11.3333V12.6667H12.6667V11.3333H14V14ZM2 2H7.33333V7.33333H2V2ZM8.66667 2H14V7.33333H8.66667V2ZM2 8.66667H7.33333V14H2V8.66667ZM12 8.66667H14V10H12V8.66667ZM4 4V5.33333H5.33333V4H4ZM4 10.6667V12H5.33333V10.6667H4ZM10.6667 4V5.33333H12V4H10.6667Z",
    fill: "#265BB6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_314_1572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrLogo);
export default __webpack_public_path__ + "static/media/qrLogo.bb66f46f1e20eac2d826155e42fe89f0.svg";
export { ForwardRef as ReactComponent };